/**
 * @generated SignedSource<<36195ba1dfadae12e56992e14e7c86ce>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type loomPersonalization_entryPoints$data = {
  readonly confluence_loomEntryPoints: {
    readonly isLoomEntryPointsEnabled: boolean;
  } | null;
  readonly loom_connectedCalendars?: ReadonlyArray<{
    readonly guid: string;
  } | null> | null;
  readonly loom_settings?: {
    readonly meetingNotesEligible: boolean | null;
    readonly meetingRecordingsAvailable: boolean | null;
  } | null;
  readonly " $fragmentType": "loomPersonalization_entryPoints";
};
export type loomPersonalization_entryPoints$key = {
  readonly " $data"?: loomPersonalization_entryPoints$data;
  readonly " $fragmentSpreads": FragmentRefs<"loomPersonalization_entryPoints">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "loomPersonalization_entryPoints"
};

(node as any).hash = "1a2dbd3d5331c836d8c0f69369a738bf";

export default node;
